var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-image',{style:(_vm.styleObj),attrs:{"src":_vm.filePath,"preview-src-list":_vm.srcList}})
}
var staticRenderFns = []

export { render, staticRenderFns }